import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurtempo() {



  const cardData =
  {
    keyword: 'Pune to Kolhapur Tempo Traveller Rent ',
    heading: 'Sanavi Travels: Pune to Kolhapur Tempo Traveller Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Kolhapur Tempo Traveller Rent, providing safe, comfortable, and hassle-free travel solutions for families, corporate teams, tourists, and group travelers journeying from Pune to Kolhapur. Our fleet of 9, 12, 13, 14, 17, and 26 seater tempo travellers is well-maintained with spacious seating, ample legroom, push-back seats, air-conditioning, and sufficient luggage space to ensure a smooth long-distance journey. With experienced drivers, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees a punctual and comfortable travel experience. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Kolhapur attractions such as Mahalaxmi Temple, Rankala Lake, Panhala Fort, New Palace Museum, and local cultural sites. Choose Sanavi Travels for trusted Pune to Kolhapur tempo traveller rental services, delivering comfort, safety, and a seamless long-distance group travel experience.',

    top: 'Top Places to Visit in Kolhapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Mahalakshmi Temple",
    "description": "Mahalakshmi Temple in Kolhapur is a historic temple dedicated to Goddess Mahalakshmi, one of the 51 Shakti Peethas. Built in the 7th century, it showcases intricate stone carvings and traditional Maratha architecture. The temple attracts thousands of devotees, especially during Navratri. It represents devotion, heritage, and Kolhapur’s spiritual legacy."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is a majestic hill fort near Kolhapur, known for its strategic significance and historical battles. Spread across lush hills, it features gateways, watchtowers, and ancient temples. The fort offers panoramic views of the surrounding countryside. Panhala Fort embodies Maratha valor, history, and architectural brilliance."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a scenic freshwater lake in Kolhapur city, surrounded by gardens, walking paths, and historic temples. Boating and evening strolls are popular activities. The lake provides a serene escape and is a favorite among locals and tourists. Rankala Lake reflects the natural beauty and cultural charm of Kolhapur."
  },
  {
    "title": "New Palace (Shahu Palace)",
    "description": "The New Palace in Kolhapur, also known as Shahu Palace, is a grand palace showcasing Maratha architectural style with European influences. It houses a museum displaying royal artifacts, weapons, and memorabilia of the Kolhapur royal family. The palace is a cultural and historical landmark, symbolizing royal heritage."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Jyotiba Temple is a sacred hilltop shrine dedicated to Lord Jyotiba, located near Kolhapur. Pilgrims climb numerous steps to reach the temple, offering prayers and seeking blessings. Festivals, especially the annual fair, attract thousands of devotees. Jyotiba Temple combines spirituality with panoramic hill views."
  },
  {
    "title": "Chandoli National Park",
    "description": "Chandoli National Park, near Kolhapur, is part of the Western Ghats biodiversity hotspot. It is home to wildlife including leopards, deer, and exotic birds. Trekking, wildlife spotting, and nature walks are popular activities. The park showcases the rich ecological diversity of the region."
  },
  {
    "title": "Shalini Palace",
    "description": "Shalini Palace, located in Kolhapur, is a beautiful heritage palace built during the early 20th century. Surrounded by gardens and a scenic lake, it reflects European architectural influences. The palace is now a heritage hotel and tourist attraction, offering a glimpse into royal lifestyle."
  },
  {
    "title": "Bhogawati Ganpati Temple",
    "description": "Bhogawati Ganpati Temple is an important religious site in Kolhapur, dedicated to Lord Ganesha. Devotees visit daily to offer prayers and seek blessings. The temple is also significant during Ganesh Chaturthi celebrations. It represents Kolhapur’s spiritual and religious traditions."
  },
  {
    "title": "Kumbhari Lake",
    "description": "Kumbhari Lake is a tranquil spot near Kolhapur, ideal for picnics, birdwatching, and photography. Surrounded by greenery and hills, it offers a peaceful retreat for nature lovers. The lake enhances the scenic and ecological appeal of Kolhapur."
  },
  {
    "title": "Bhuikot Fort",
    "description": "Bhuikot Fort, located in Kolhapur city, is a historical fort with connections to the Maratha and Adilshahi dynasties. The fort complex includes temples, bastions, and defensive structures. It offers insight into Kolhapur’s rich history and strategic significance. Bhuikot Fort stands as a testament to the city’s heritage and valor."
  }
]
,




"services": [
  {
    "name": "Pune to Kolhapur Tempo Traveller Rent",
    "description": "Pune to Kolhapur Tempo Traveller Rent provides comfortable and reliable vehicles for groups traveling from Pune to Kolhapur. Ideal for family trips, corporate outings, or group tours, these tempo travellers offer spacious seating, luggage space, and professional drivers ensuring a safe and smooth journey. Flexible booking options and well-maintained vehicles make long-distance travel convenient and hassle-free."
  },
  {
    "name": "Kolhapur Tempo Traveller Hire from Pune",
    "description": "Kolhapur Tempo Traveller Hire from Pune offers private and group rental services for trips to Kolhapur. Equipped with comfortable seating, air-conditioning, and safety features, these vehicles are perfect for families, friends, or corporate groups. Experienced drivers ensure timely arrivals and a stress-free journey for all travelers."
  },
  {
    "name": "AC Tempo Traveller Pune to Kolhapur",
    "description": "AC Tempo Traveller Pune to Kolhapur provides air-conditioned vehicles for a comfortable long-distance journey. Ideal for family trips, corporate travel, or group tours, these tempo travellers feature spacious interiors and luggage-friendly layouts. Professional chauffeurs ensure safety and smooth travel along highways and city roads."
  },
  {
    "name": "Luxury Tempo Traveller Kolhapur Trip",
    "description": "Luxury Tempo Traveller Kolhapur Trip offers premium vehicles for a stylish and comfortable travel experience. Equipped with reclining seats, entertainment options, and ample luggage space, these luxury tempo travellers cater to VIP groups, corporate outings, or family trips seeking elegance and convenience during the journey."
  },
  {
    "name": "Family Tempo Traveller Kolhapur",
    "description": "Family Tempo Traveller Kolhapur ensures safe and comfortable travel for families visiting Kolhapur. With spacious seating, luggage space, and child-friendly features, this service prioritizes comfort and convenience, making weekend trips or longer journeys stress-free and enjoyable."
  },
  {
    "name": "Group Travel Tempo Traveller Kolhapur",
    "description": "Group Travel Tempo Traveller Kolhapur is ideal for friends, office groups, or tour operators traveling together. Spacious vehicles, professional drivers, and organized pick-up/drop-off arrangements make group travel safe, comfortable, and convenient for all passengers."
  },
  {
    "name": "Affordable Tempo Traveller Kolhapur",
    "description": "Affordable Tempo Traveller Kolhapur provides budget-friendly rental options for groups or families traveling to Kolhapur without compromising on comfort or safety. Well-maintained vehicles and skilled drivers ensure a smooth and reliable journey at economical rates."
  },
  {
    "name": "Chauffeur Driven Tempo Traveller Kolhapur",
    "description": "Chauffeur Driven Tempo Traveller Kolhapur provides professional drivers to handle all routes, traffic, and navigation, ensuring passengers can relax throughout the journey. Safe, reliable, and comfortable, this service is ideal for families, friends, or corporate travelers."
  },
  {
    "name": "Best Tempo Traveller Pune to Kolhapur",
    "description": "Best Tempo Traveller Pune to Kolhapur offers top-quality vehicles and professional services for a superior travel experience. Comfortable interiors, experienced drivers, and attention to passenger convenience ensure a smooth, safe, and enjoyable trip for families, friends, and corporate groups."
  },
  {
    "name": "Pune Kolhapur Travel Vehicle",
    "description": "Pune Kolhapur Travel Vehicle provides dependable and comfortable tempo travellers for long-distance travel. Spacious interiors, luggage-friendly seating, and professional drivers ensure smooth and safe journeys for tourists, pilgrims, and group travelers."
  },
  {
    "name": "Tourist Tempo Traveller Kolhapur",
    "description": "Tourist Tempo Traveller Kolhapur offers vehicles for sightseeing and leisure travel in and around Kolhapur. With ample seating, luggage space, and experienced drivers, this service ensures tourists enjoy their trip comfortably and conveniently."
  },
  {
    "name": "Religious Tour Tempo Traveller",
    "description": "Religious Tour Tempo Traveller caters to pilgrims visiting temples and sacred sites in Kolhapur. Spacious, well-maintained vehicles with professional drivers make the journey safe, convenient, and hassle-free for devotees."
  },
  {
    "name": "Long Distance Tempo Traveller Pune",
    "description": "Long Distance Tempo Traveller Pune provides vehicles designed for comfortable extended journeys from Pune to Kolhapur and nearby regions. These tempo travellers offer ample legroom, luggage space, and experienced chauffeurs to ensure a smooth and stress-free ride."
  },
  {
    "name": "Weekend Trip Tempo Traveller Kolhapur",
    "description": "Weekend Trip Tempo Traveller Kolhapur is perfect for short getaways and weekend travel. Comfortable, spacious, and reliable, these vehicles make it easy for families, friends, or corporate groups to enjoy a relaxed trip without travel-related stress."
  },
  {
    "name": "Kolhapur Darshan Tempo Traveller",
    "description": "Kolhapur Darshan Tempo Traveller provides convenient and comfortable transport for visitors planning temple visits or religious tours in Kolhapur. Professional drivers, well-maintained vehicles, and ample seating ensure a hassle-free and enjoyable darshan experience."
  }
],
"tableData": [
  ["Pune to Kolhapur Tempo Traveller Rent", "Kolhapur Tempo Traveller Hire from Pune"],
  ["AC Tempo Traveller Pune to Kolhapur", "Luxury Tempo Traveller Kolhapur Trip"],
  ["Family Tempo Traveller Kolhapur", "Group Travel Tempo Traveller Kolhapur"],
  ["Affordable Tempo Traveller Kolhapur", "Chauffeur Driven Tempo Traveller Kolhapur"],
  ["Best Tempo Traveller Pune to Kolhapur", "Pune Kolhapur Travel Vehicle"],
  ["Tourist Tempo Traveller Kolhapur", "Religious Tour Tempo Traveller"],
  ["Long Distance Tempo Traveller Pune", "Weekend Trip Tempo Traveller Kolhapur"],
  ["Kolhapur Darshan Tempo Traveller", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Kolhapur Tempo Traveller Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Pune to Kolhapur Tempo Traveller rental services, ideal for group trips, family tours, corporate travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced Tempo Travellers with ample seating and luggage space for a smooth and enjoyable journey from Pune to Kolhapur."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Kolhapur Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune to Kolhapur highways and surrounding routes, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Kolhapur Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Tempo Traveller rental plans tailored to your Pune to Kolhapur travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Kolhapur Tempo Traveller rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Kolhapur Tempo Traveller rentals?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for travel from Pune to Kolhapur.'
  },
  {
    question: 'How can I book a Pune to Kolhapur Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of Tempo Travellers are available for Pune to Kolhapur travel?',
    answer: 'We provide various seating options including 9-seater, 12-seater, 13-seater, 17-seater, and larger Tempo Travellers as per your group size.'
  },
  {
    question: 'Are drivers included with the Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers familiar with the Pune–Kolhapur route.'
  },
  {
    question: 'Is the Pune to Kolhapur Tempo Traveller service available 24x7?',
    answer: 'Yes, our Pune to Kolhapur Tempo Traveller service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Kolhapur Tempo Traveller rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Kolhapur trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajiv Patil',
    feedback: 'Booked a Pune to Kolhapur Tempo Traveller with Sanavi Travels. Comfortable vehicle, excellent driver, and great travel experience from start to finish.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    feedback: 'Highly recommended! Clean and spacious Tempo Traveller, on-time pickup, and smooth journey to Kolhapur. Very satisfied with Sanavi Travels.',
    rating: 5
  }
];




































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Tempo Traveller Rent - Sanavi Travels",
  "description": "Book Pune to Kolhapur Tempo Traveller on rent with Sanavi Travels. AC and luxury tempo travellers for family trips, group travel, religious darshan, weekend tours, and long-distance journeys with chauffeur-driven, safe, and comfortable travel services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Pune to Kolhapur Tempo Traveller Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury Tempo Travellers from Pune to Kolhapur with Sanavi Travels. Ideal for family trips, group travel, religious darshan, weekend tours, and comfortable long-distance journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokolhapurtempo;